import { ProviderCard } from '../CareProviderProfileCard/ProviderCard';
import { ResultsContainer } from './ResultsContainer';
import Card from '@/components/atoms/Card/Card';
import { BannerImageWithCard } from '@/components/atoms/BannerImageWithCard/BannerImageWithCard';
import { NavLink } from '@/components/atoms/NavLink/NavLink';
import { caresourcerHomeUrl } from '@/directory/constants';

interface ResultListProps {
  locationName: string;
  items: any[];
  onCardReadMoreClick?: (val: string) => void;
  variant?: 'long';
  mapLink?: string;
}

export function ResultList({
  variant,
  items,
  onCardReadMoreClick,
  mapLink,
}: ResultListProps) {
  return (
    <>
      {items?.length ? (
        <ResultsContainer variant={variant}>
          {mapLink && (
            <Card isFullWidth isNoPadding to={mapLink}>
              <BannerImageWithCard bannerImageUrl={'/images/map_results.png'}>
                <NavLink
                  label='View results on a map'
                  isNoUnderline
                  href={mapLink}
                />
              </BannerImageWithCard>
            </Card>
          )}
          {items.map((item: any) => (
            <ProviderCard
              key={item.regulatoryId}
              provider={item}
              variant={variant}
              onReadMoreClick={onCardReadMoreClick}
            />
          ))}
        </ResultsContainer>
      ) : null}
    </>
  );
}
